<template>

  <tr class="detail">
    <td colspan="8">
      <h4>상세정보</h4>
      <div class="result-tbl m-t-sm">
        <table class="tbl">
          <tbody>
          <tr>
            <th>이름

            </th>
            <td>{{item.employee.empName}}</td>
            <th>이메일
            </th>
            <td>{{item.employee.empEmail}}</td>
          </tr>
          <tr>
            <th>사번
              <!--button class="btn btn-sm line-3 ml-5">Edit</button-->
            </th>
            <td>{{item.empNo}}</td>
            <!--th>사용자타입</th>
            <td>{{item.employee.empType}}
            </td-->
            <col-field  label="사용자타입" :editMode="true" @confirmInput="update()" >
              <dropdown v-model="userLevelCode" :datasource="getUserLevelList" displayName="userLevelStr" valueName="userLevelCode" placeholder="IDC 권한 " :editMode="true" :isAuto="true"/>
            </col-field>
          </tr>
          <tr>
             <col-field  label="IDC 권한 " :editMode="true" @confirmInput="update()">
              <dropdown :datasource="idcList" displayName="locationName" valueName="locationCode" placeholder="IDC 권한 " :showCheckbox="true" :isMultiple="true" :editMode="true" :isAuto="true"/>
            </col-field>
            <col-field  label="주 IDC 선택" :editMode="true" @confirmInput="update()" >
              <dropdown v-model="mainIdc" :datasource="getMainIdcDatasource()" displayName="locationName" valueName="locationCode" placeholder="IDC 권한 " :editMode="true" :isAuto="true"/>
            </col-field>
          </tr>
          <tr>
            <th>메모
            </th>
            <td></td>

          </tr>
        </tbody></table>
      </div>
    </td>
  </tr>

</template>

<script>
import ColField from '@/components/ColField.vue';
import RowField from '@/components/RowField.vue';
import Input from "@/components/Input.vue"
import LocationBase from '@/components/common/locationBase'
import Dropdown from '@/components/Dropdown.vue';


export default {
  mixins: [LocationBase],
  props: ['item', 'idcList'],
  components: {
    Input,
    ColField,
    RowField,
    Dropdown,
  },
  data() {
    return {
      statusDropList: [{name: '전체', value: null, isChecked: true}, {name: '담당임직원 승인대기', value: 1}, {name: '내부결재 진행중', value: 2}, {name: '승인완료', value: 3}, {name: '승인거절', value: 4}, {name: '입/퇴실완료', value: 4}],
      //idcList: null,
      mainIdc: null,
      userLevelCode: null,
    }
  },
  computed: {
    getMainIdc() {
      return (item)=>{
        if(item.userIdcAuthList){
          var mainIdcList = item.userIdcAuthList.filter(x=>x.isDefault == 1);
          if(mainIdcList.length)
            return mainIdcList[0].location.locationCode;
        }

      }
    },
    getVisitLocationList(){
      return JSON.parse(this.item.visitLocation)
    },
    getVisitType(){
      return (item) =>{
        if(item.visitType)
          return item.visitType.visitTypeStr
      }
    },
    getStatus(){
      return (item) => {
        var color = 'grey'
        if(item.statusCode == 1 || item.statusCode == 2)
          color = 'yellow';
        if(item.statusCode >= 3 && item.statusCode <= 8)
          color = 'green';
        if(item.statusCode == 4)
          color = 'red';
        return color;
      }
    },
    assetList(){
      var assetList = this.item.assetList;
      var visitorAssetList = this.item.assetList;
      return this.item.assetList;
    },
    getUserLevelList(){
      // return this.$store.getters['dropdown/dataprovider'].userLevel
      return this.$store.getters['dropdown/dataprovider'].userLevel.filter(data => data.userLevelCode <= this.$store.state.login.userLevel)
    },
    getLocationSoruce(){
      return (location, chekedLocation) =>{
        var locationList = this.getParseLocation(location);
        var chekedLocationList = this.getParseLocation(chekedLocation);
        locationList.forEach(x => {
          x.reserved = true;
          if(chekedLocationList.filter((y) => y.key == x.key).length > 0){

            x.checked = true;
          }
        });
        return locationList;
      }
    },
    getIdcAuth(){
      return (item) => {
        return item.userIdcAuthList.map(x=>x.location.locationName).join(', ');
      }
    },
  },

  mounted(){
    this.init();

  },
  methods: {
    getMainIdcDatasource(){
      return this.idcList.filter(x=>x.checked)
    },
    init(){
     this.mainIdc = this.getMainIdc(this.item);
     this.userLevelCode = this.item.userLevel.userLevelCode;
     this.$forceUpdate();
    },
    update() {
      //var o = this.copyNew(this.item);
      var that = this;
      var userIdcAuthList = [];
      var updateIdcList =  this.copyNew(this.idcList);

      updateIdcList.filter(x=>x.checked).forEach(x=>{
        x.isDefault  = x.locationCode == that.mainIdc ? 1 : 0;
        var o = {empNo: that.item.empNo, locationCode: x.locationCode, isDefault: x.isDefault};
        userIdcAuthList.push(o);
      })


      var o = {
        empNo: this.item.empNo,
        userIdcAuthList: userIdcAuthList,
        userLevelCode : this.userLevelCode
      }
      this.$http.put('/api/private/user', o)
        .then((result) => {
          that.item.userIdcAuthList
          // that.$toast.success('사용자 정보가 수정되었습니다.');
          this.noti('완료', '사용자 정보가 수정되었습니다.', 'success');
          that.$http.get('/api/private/user/' + that.item.empNo).then((result)=>{
            that.$emit('updateRow', result.data);
          })
        }).catch((e) =>{
          console.log(e);
      })
    },


  }
}
</script>

<style>

</style>
